import { assert } from '../app/logger.js';
import { app } from '../app/app.js';
import { navigation } from '../app/navigation.js';
import { PopupButtonControl } from '../controls/popup_button_control.js';
import { profile } from '../data/profile.js';
import { listenToEvent } from '../util/listen_to_event.js';

class ProfileButton extends PopupButtonControl {
  initialize() {
    super.initialize();

    this.setItems([
      {
        img: '/images/user-16.png',
        name: 'Profile',
        title: 'Profile',
        type: 'profile-link',
      },
      {
        img: '/images/sign-out-16.png',
        name: 'Logout',
        title: 'Logout',
        type: 'logout-link',
      },
    ]);

    listenToEvent(
      this,
      'itemselect',
      ev => {
        let type = ev.detail && ev.detail.type;
        assert(type, `[control:profilebutton] no type for ${ev.detail}`);
        switch (type) {
          case 'profile-link':
            navigation.toProfile();
            this.selected = null;
            break;

          case 'logout-link':
            return app.logout();

          default:
            break;
        }
      },
      {
        blockUI: true,
      }
    );

    profile.pipe({
      name: v => (this.label = v),
      avatar: v => (this.img = v),
    });
  }

  static tagName = 'profile-button';

  static properties = {
    label: {
      attribute: true,
      preset(v) {
        return v.replace(/\s.*$/, '');
      },
      set(v) {
        this.userNameElement.textContent = v;
      },
    },
  };

  static boxLabelMarkup = `
    <span class='profile-button-username-label'></span>
    <img class='down-arrow' src='/images/arrow-down-16.png'>
  `;

  static get selectors() {
    return Object.assign(
      {
        UserName: `.profile-button-username-label`,
      },
      super.selectors
    );
  }

  static elements = {
    userNameElement: this.selectors.UserName,
  };
}

ProfileButton.defineCustomElement();

export { ProfileButton };
